import React, { useEffect, useState } from 'react';

// Floating "Aduan WhatsApp AI" button on the public pages. The number comes from the API (WHATSAPP_AI_NUMBER),
// so each server links to its own complaint bot and the button stays hidden until a number is set.
const CACHE_KEY = 'app_whatsapp_ai';
const DEFAULT_TEXT = 'Assalamualaikum, saya ingin membuat aduan.';

const readCache = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    } catch (e) {
        return null;
    }
};

const SharedWhatsAppAiButton = () => {
    const [config, setConfig] = useState(readCache);

    useEffect(() => {
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) return undefined;
        let cancelled = false;
        fetch(`${apiUrl}/app-info`, { headers: { Accept: 'application/json' } })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (cancelled || !data) return;
                const next = data.whatsapp_ai || { number: null };
                setConfig(next);
                try {
                    sessionStorage.setItem(CACHE_KEY, JSON.stringify(next));
                } catch (e) {
                    // Storage unavailable: the button still shows for this page view.
                }
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    const number = String(config?.number || '').replace(/\D+/g, '');
    if (!number) return null;

    const href = `https://wa.me/${number}?text=${encodeURIComponent(config.text || DEFAULT_TEXT)}`;

    return (
        <a
            className="public-whatsapp-ai"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Buat aduan melalui WhatsApp AI"
            title="Buat aduan melalui WhatsApp AI"
        >
            <i className="bi bi-whatsapp" aria-hidden="true"></i>
            <span>Aduan WhatsApp AI</span>
        </a>
    );
};

export default SharedWhatsAppAiButton;
